module.exports = __webpack_public_path__ + "img/bank_of_china@2x..6cc4ec56.png";